var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invoice-index-page invoices main-content" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("h3", { staticClass: "page-title" }, [
          _vm._v(_vm._s(_vm.$t("preapproved_invoices.title"))),
        ]),
        _vm._v(" "),
        _c("ol", { staticClass: "breadcrumb" }, [
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c(
                "router-link",
                {
                  attrs: { slot: "item-title", to: "dashboard" },
                  slot: "item-title",
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("general.home")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c(
                "router-link",
                { attrs: { slot: "item-title", to: "#" }, slot: "item-title" },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("preapproved_invoices.title")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "page-actions row" }, [
          _vm.userType === "anchor"
            ? _c(
                "div",
                { staticClass: "col-xs-2 mr-4" },
                [
                  _c(
                    "base-button",
                    {
                      attrs: { color: "theme", icon: "file", size: "large" },
                      on: { click: _vm.ImportPaymentFile },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("general.import_payment_info")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userType === "anchor"
            ? _c(
                "div",
                { staticClass: "col-xs-2 mr-4" },
                [
                  _c(
                    "base-button",
                    {
                      attrs: { color: "theme", icon: "file", size: "large" },
                      on: { click: _vm.ImportInvoiceFile },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("general.invoice_import")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-2 mr-4" },
            [
              _c(
                "base-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.totalInvoices || _vm.filtersApplied,
                      expression: "totalInvoices || filtersApplied",
                    },
                  ],
                  attrs: {
                    outline: true,
                    icon: _vm.filterIcon,
                    size: "large",
                    color: "theme",
                    "right-icon": "",
                  },
                  on: { click: _vm.toggleFilter },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("general.filter")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showFilters,
                expression: "showFilters",
              },
            ],
            staticClass: "filter-section",
          },
          [
            _c("div", { staticClass: "row" }, [
              _vm.userType == "super-admin" || _vm.userType == "supplier"
                ? _c(
                    "div",
                    { staticClass: "col-sm-4" },
                    [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v(
                          _vm._s(_vm.$tc("customers.customer", 1)) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("base-customer-select", {
                        ref: "customerSelect",
                        on: {
                          select: _vm.onSelectCustomer,
                          deselect: _vm.clearCustomerSearch,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.advanceOption == false
                ? _c(
                    "div",
                    { staticClass: "col-sm-4" },
                    [
                      _vm.userType == "funder"
                        ? _c("label", { staticClass: "form-label" }, [
                            _vm._v(_vm._s(_vm.$tc("customers.customer", 1))),
                          ])
                        : _c("label", { staticClass: "form-label" }, [
                            _vm._v(_vm._s(_vm.$t("invoices.supplier", 1))),
                          ]),
                      _vm._v(" "),
                      _c("base-select", {
                        attrs: {
                          options: _vm.suppliers,
                          searchable: true,
                          "show-labels": false,
                          "allow-empty": true,
                          tabindex: 8,
                          placeholder: _vm.$t("customers.type_or_click"),
                          label: "company_name",
                          "track-by": "company_id",
                        },
                        model: {
                          value: _vm.filters.supplier,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "supplier", $$v)
                          },
                          expression: "filters.supplier",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4" },
                [
                  _c("label", [_vm._v(_vm._s(_vm.$t("invoices.status")))]),
                  _vm._v(" "),
                  _vm.userType == "supplier"
                    ? _c("base-select", {
                        attrs: {
                          options: _vm.InvoiceStatuses,
                          "group-select": false,
                          searchable: true,
                          "show-labels": false,
                          placeholder: _vm.$t("general.select_a_status"),
                          "group-values": "options",
                          "group-label": "label",
                          "track-by": "name",
                          label: "name",
                        },
                        on: {
                          remove: function ($event) {
                            return _vm.clearStatusSearch()
                          },
                        },
                        model: {
                          value: _vm.filters.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "status", $$v)
                          },
                          expression: "filters.status",
                        },
                      })
                    : _vm.userType == "anchor"
                    ? _c("base-select", {
                        attrs: {
                          options: _vm.anchorInvoiceStatuses,
                          "group-select": false,
                          searchable: true,
                          "show-labels": false,
                          placeholder: _vm.$t("general.select_a_status"),
                          "group-values": "options",
                          "group-label": "label",
                          "track-by": "name",
                          label: "name",
                        },
                        on: {
                          remove: function ($event) {
                            return _vm.clearStatusSearch()
                          },
                        },
                        model: {
                          value: _vm.filters.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "status", $$v)
                          },
                          expression: "filters.status",
                        },
                      })
                    : _c("base-select", {
                        attrs: {
                          options: _vm.InvoiceStatusesExcludeDraft,
                          "group-select": false,
                          searchable: true,
                          "show-labels": false,
                          placeholder: _vm.$t("general.select_a_status"),
                          "group-values": "options",
                          "group-label": "label",
                          "track-by": "name",
                          label: "name",
                        },
                        on: {
                          remove: function ($event) {
                            return _vm.clearStatusSearch()
                          },
                        },
                        model: {
                          value: _vm.filters.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "status", $$v)
                          },
                          expression: "filters.status",
                        },
                      }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4" },
                [
                  _c("label", [_vm._v(_vm._s(_vm.$t("invoices.prePayment")))]),
                  _vm._v(" "),
                  _vm.userType == "supplier"
                    ? _c("base-select", {
                        attrs: {
                          options: _vm.InvoicePrepaymentOptions,
                          "group-select": false,
                          searchable: true,
                          "show-labels": false,
                          placeholder: _vm.$t("general.select_a_status"),
                          "group-values": "options",
                          "group-label": "label",
                          "track-by": "name",
                          label: "name",
                        },
                        on: {
                          remove: function ($event) {
                            return _vm.clearStatusSearch()
                          },
                        },
                        model: {
                          value: _vm.filters.request_level,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "request_level", $$v)
                          },
                          expression: "filters.request_level",
                        },
                      })
                    : _vm.userType == "super_admin"
                    ? _c("base-select", {
                        attrs: {
                          options: _vm.SuperAdminInvoicePrepaymentOptions,
                          "group-select": false,
                          searchable: true,
                          "show-labels": false,
                          placeholder: _vm.$t("general.select_a_status"),
                          "group-values": "options",
                          "group-label": "label",
                          "track-by": "name",
                          label: "name",
                        },
                        on: {
                          remove: function ($event) {
                            return _vm.clearStatusSearch()
                          },
                        },
                        model: {
                          value: _vm.filters.request_level,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "request_level", $$v)
                          },
                          expression: "filters.request_level",
                        },
                      })
                    : _vm.userType == "anchor"
                    ? _c("base-select", {
                        attrs: {
                          options: _vm.AnchorInvoicePrepaymentOptions,
                          "group-select": false,
                          searchable: true,
                          "show-labels": false,
                          placeholder: _vm.$t("general.select_a_status"),
                          "group-values": "options",
                          "group-label": "label",
                          "track-by": "name",
                          label: "name",
                        },
                        on: {
                          remove: function ($event) {
                            return _vm.clearRequestLevelSearch()
                          },
                        },
                        model: {
                          value: _vm.filters.request_level,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "request_level", $$v)
                          },
                          expression: "filters.request_level",
                        },
                      })
                    : _vm.userType == "funder"
                    ? _c("base-select", {
                        attrs: {
                          options: _vm.FunderInvoicePrepaymentOptions,
                          "group-select": false,
                          searchable: true,
                          "show-labels": false,
                          placeholder: _vm.$t("general.select_a_status"),
                          "group-values": "options",
                          "group-label": "label",
                          "track-by": "name",
                          label: "name",
                        },
                        on: {
                          remove: function ($event) {
                            return _vm.clearRequestLevelSearch()
                          },
                        },
                        model: {
                          value: _vm.filters.request_level,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "request_level", $$v)
                          },
                          expression: "filters.request_level",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.userType == "supplier" && _vm.userType == "anchor"
                ? _c(
                    "div",
                    { staticClass: "col-sm-4" },
                    [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v(_vm._s(_vm.$t("general.from"))),
                      ]),
                      _vm._v(" "),
                      _c("base-date-picker", {
                        attrs: {
                          "calendar-button": true,
                          "calendar-button-icon": "calendar",
                        },
                        model: {
                          value: _vm.filters.from_date,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "from_date", $$v)
                          },
                          expression: "filters.from_date",
                        },
                      }),
                    ],
                    1
                  )
                : _vm.userType == "funder"
                ? _c(
                    "div",
                    { staticClass: "col-sm-4" },
                    [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v(_vm._s(_vm.$t("general.from"))),
                      ]),
                      _vm._v(" "),
                      _c("base-date-picker", {
                        attrs: {
                          "calendar-button": true,
                          "calendar-button-icon": "calendar",
                        },
                        model: {
                          value: _vm.filters.financing_approved_date_from,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.filters,
                              "financing_approved_date_from",
                              $$v
                            )
                          },
                          expression: "filters.financing_approved_date_from",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userType == "supplier" && _vm.userType == "anchor"
                ? _c(
                    "div",
                    { staticClass: "col-sm-4" },
                    [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v(_vm._s(_vm.$t("general.to"))),
                      ]),
                      _vm._v(" "),
                      _c("base-date-picker", {
                        attrs: {
                          "calendar-button": true,
                          "calendar-button-icon": "calendar",
                        },
                        model: {
                          value: _vm.filters.to_date,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "to_date", $$v)
                          },
                          expression: "filters.to_date",
                        },
                      }),
                    ],
                    1
                  )
                : _vm.userType == "funder"
                ? _c(
                    "div",
                    { staticClass: "col-sm-4" },
                    [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v(_vm._s(_vm.$t("general.to"))),
                      ]),
                      _vm._v(" "),
                      _c("base-date-picker", {
                        attrs: {
                          "calendar-button": true,
                          "calendar-button-icon": "calendar",
                        },
                        model: {
                          value: _vm.filters.financing_approved_date_to,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.filters,
                              "financing_approved_date_to",
                              $$v
                            )
                          },
                          expression: "filters.financing_approved_date_to",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4" },
                [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("invoices.invoice_number"))),
                  ]),
                  _vm._v(" "),
                  _c("base-input", {
                    attrs: { icon: "hashtag" },
                    model: {
                      value: _vm.filters.reference_number,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "reference_number", $$v)
                      },
                      expression: "filters.reference_number",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.userType == "supplier" || _vm.userType == "super_admin"
                ? _c(
                    "div",
                    { staticClass: "col-sm-4" },
                    [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("deliveryNotes.delivery_note_number"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("base-input", {
                        attrs: { icon: "hashtag" },
                        model: {
                          value: _vm.filters.delivery_note_number,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "delivery_note_number", $$v)
                          },
                          expression: "filters.delivery_note_number",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "clear-filter", on: { click: _vm.clearFilter } },
              [_vm._v(_vm._s(_vm.$t("general.clear_all")))]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showEmptyScreen,
              expression: "showEmptyScreen",
            },
          ],
          staticClass: "col-xs-1 no-data-info",
          attrs: { align: "center" },
        },
        [
          _c("moon-walker-icon", { staticClass: "mt-5 mb-4" }),
          _vm._v(" "),
          _c("div", { staticClass: "row", attrs: { align: "center" } }, [
            _c("label", { staticClass: "col title" }, [
              _vm._v(_vm._s(_vm.$t("invoices.no_invoices"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "label",
              {
                staticClass: "description col mt-1",
                attrs: { align: "center" },
              },
              [_vm._v(_vm._s(_vm.$t("invoices.list_of_invoices")))]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showEmptyScreen,
              expression: "!showEmptyScreen",
            },
          ],
          staticClass: "table-container",
        },
        [
          _c(
            "div",
            { staticClass: "table-actions mt-5" },
            [
              _c("p", { staticClass: "table-stats" }, [
                _vm._v("\n        " + _vm._s(_vm.$t("general.showing")) + ": "),
                _c("b", [_vm._v(_vm._s(_vm.invoices.length))]),
                _vm._v("\n        " + _vm._s(_vm.$t("general.of")) + " "),
                _c("b", [_vm._v(_vm._s(_vm.totalInvoices))]),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "tabs" }, [
                _c(
                  "li",
                  {
                    staticClass: "tab",
                    on: {
                      click: function ($event) {
                        return _vm.getStatus("")
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        class: [
                          "tab-link",
                          {
                            "a-active":
                              _vm.filters.request_level.value === "" &&
                              (_vm.filters.status.value === "" ||
                                _vm.filters.status.value === null) &&
                              (_vm.filters.funder_receiver === "" ||
                                _vm.filters.funder_receiver === null) &&
                              (_vm.filters.supplier_receiver === "" ||
                                _vm.filters.supplier_receiver === null) &&
                              (_vm.filters.settlement === "" ||
                                _vm.filters.settlement === null) &&
                              (_vm.filters.payment === "" ||
                                _vm.filters.payment === null) &&
                              (_vm.filters.prepayment === "" ||
                                _vm.filters.prepayment === null),
                          },
                        ],
                        attrs: { href: "#" },
                      },
                      [_vm._v(_vm._s(_vm.$t("general.all")) + "\n          ")]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _vm.showAction
                    ? _c(
                        "v-dropdown",
                        { attrs: { "show-arrow": false } },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "table-actions-button dropdown-toggle",
                              attrs: { slot: "activator", href: "#" },
                              slot: "activator",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("general.actions")) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.userType === "anchor"
                            ? _c("v-dropdown-item", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: _vm.makeMultipleInvoicePayment,
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "dropdown-item-icon",
                                      attrs: { icon: ["fas", "credit-card"] },
                                    }),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("general.make_payment")) +
                                        "\n            "
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm.userType === "funder"
                            ? _c("v-dropdown-item", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.makeMultipleBulkProcess(
                                          "Pending"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("general.bulk_pending")) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.makeMultipleBulkProcess(
                                          "Pre-payment"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("general.bulk_pre_payment")
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm.userType === "supplier"
                            ? _c(
                                "v-dropdown-item",
                                [
                                  _c("v-dropdown-item", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.makeMultipleBulkProcess(
                                              "Eligible"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("general.bulk_requested")
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-dropdown-item", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.makeMultipleBulkProcess(
                                              "Financed"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                "general.financed_approved"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-dropdown-item", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.bulkPrePaymentRequest(
                                              "Prepaid"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("general.bulk_settled")
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm.userType === "super_admin"
                            ? _c("v-dropdown-item", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.makeMultipleBulkProcessSuper(
                                          "Verified"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t(
                                            "general.bulk_request_to_Verified"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.makeMultipleBulkProcessSuper(
                                          "SendToFunder"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("general.bulk_send_to_funder")
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.userType == "supplier"
                ? _c(
                    "div",
                    { staticClass: "col-sm-2" },
                    [
                      _c("base-customer-select", {
                        ref: "customerSelect",
                        on: {
                          select: _vm.onSelectCustomer,
                          deselect: _vm.clearCustomerSearch,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.userType == "funder"
                ? _c(
                    "div",
                    { staticClass: "col-sm-2" },
                    [
                      _c("base-select", {
                        attrs: {
                          options: _vm.suppliers,
                          searchable: true,
                          "show-labels": false,
                          "allow-empty": true,
                          tabindex: 8,
                          placeholder: _vm.$t("customers.type_or_click"),
                          label: "company_name",
                          "track-by": "company_id",
                        },
                        model: {
                          value: _vm.filters.supplier,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "supplier", $$v)
                          },
                          expression: "filters.supplier",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "custom-control custom-checkbox" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectAllFieldStatus,
                  expression: "selectAllFieldStatus",
                },
              ],
              staticClass: "custom-control-input",
              attrs: { id: "select-all", type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.selectAllFieldStatus)
                  ? _vm._i(_vm.selectAllFieldStatus, null) > -1
                  : _vm.selectAllFieldStatus,
              },
              on: {
                change: [
                  function ($event) {
                    var $$a = _vm.selectAllFieldStatus,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          (_vm.selectAllFieldStatus = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.selectAllFieldStatus = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.selectAllFieldStatus = $$c
                    }
                  },
                  _vm.selectAllInvoices,
                ],
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isRequestOngoing,
                    expression: "!isRequestOngoing",
                  },
                ],
                staticClass: "custom-control-label selectall",
                attrs: { for: "select-all" },
              },
              [
                _c("span", { staticClass: "select-all-label" }, [
                  _vm._v(_vm._s(_vm.$t("general.select_all")) + " "),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "table-component",
            {
              ref: "table",
              attrs: {
                "show-filter": false,
                data: _vm.fetchData,
                "table-class": "table",
              },
            },
            [
              _c("table-column", {
                attrs: {
                  sortable: false,
                  filterable: false,
                  "cell-class": "no-click",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (row) {
                      return [
                        _c(
                          "div",
                          { staticClass: "custom-control custom-checkbox" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectField,
                                  expression: "selectField",
                                },
                              ],
                              staticClass: "custom-control-input",
                              attrs: { id: row.id, type: "checkbox" },
                              domProps: {
                                value: row.id,
                                checked: Array.isArray(_vm.selectField)
                                  ? _vm._i(_vm.selectField, row.id) > -1
                                  : _vm.selectField,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.selectField,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = row.id,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.selectField = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.selectField = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.selectField = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("label", {
                              staticClass: "custom-control-label",
                              attrs: { for: row.id },
                            }),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _vm.userType == "funder"
                ? _c("table-column", {
                    attrs: {
                      label: _vm.$t("invoices.financing_request_date"),
                      "sort-as": "prepayment_date",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (row) {
                            return [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    row.pre_payment_request
                                      .formattedPrePaymentDate
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2473093795
                    ),
                  })
                : _c("table-column", {
                    attrs: {
                      label: _vm.$t("invoices.date"),
                      "sort-as": "invoice_date",
                      show: "formattedInvoiceDate",
                    },
                  }),
              _vm._v(" "),
              _vm.userType == "funder"
                ? _c("table-column", {
                    attrs: {
                      label: _vm.$t("invoices.promised_payment_date"),
                      "sort-as": "promised_date",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (row) {
                            return [
                              _c("p", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      row.pre_payment_request.invoice
                                        .formattedPromisedPaymentDate
                                    ) +
                                    "\n          "
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1600600768
                    ),
                  })
                : _c("table-column", {
                    attrs: {
                      label: _vm.$t("invoices.due_date"),
                      "sort-as": "due_date",
                      show: "formattedDueDate",
                    },
                  }),
              _vm._v(" "),
              _vm.userType === "super_admin" ||
              _vm.userType === "supplier" ||
              _vm.userType === "funder"
                ? _c("table-column", {
                    attrs: { label: _vm.$t("invoices.customer"), width: "20%" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (row) {
                            return [
                              row.customer.parent_account
                                ? _c("p", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          row.customer.parent_account
                                            .company_name
                                        ) +
                                        "\n          "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3955177140
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.userType === "super_admin" ||
              _vm.userType === "anchor" ||
              _vm.userType === "funder"
                ? _c("table-column", {
                    attrs: { label: _vm.$t("invoices.supplier") },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (row) {
                            return [
                              row.user
                                ? _c("p", [
                                    row.user.company && row.user.company.name
                                      ? _c("span", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(row.user.company.name) +
                                              "\n            "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      37938562
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.userType != "super_admin"
                ? _c("table-column", {
                    attrs: {
                      label: _vm.$t("invoices.status"),
                      "sort-as": "status",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (row) {
                            return row.overall_status
                              ? [
                                  _c("span", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("invoices.status"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.userType == "anchor" &&
                                  row.overall_status == "SENT"
                                    ? _c(
                                        "span",
                                        {
                                          class:
                                            "inv-status-" +
                                            row.overall_status.toLowerCase(),
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm
                                                .$t("general.received")
                                                .toUpperCase()
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm.userType == "anchor" &&
                                      row.overall_status != "SENT"
                                    ? _c(
                                        "span",
                                        {
                                          class:
                                            "inv-status-" +
                                            row.overall_status.toLowerCase(),
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              row.overall_status !=
                                                "PARTIALLY_PAID"
                                                ? row.overall_status
                                                : row.overall_status.replace(
                                                    "_",
                                                    " "
                                                  )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm.userType != "anchor"
                                    ? _c(
                                        "span",
                                        {
                                          class:
                                            "inv-status-" +
                                            row.overall_status.toLowerCase(),
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              row.overall_status !=
                                                "PARTIALLY_PAID"
                                                ? row.overall_status
                                                : row.overall_status.replace(
                                                    "_",
                                                    " "
                                                  )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              : undefined
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("table-column", {
                attrs: {
                  label: _vm.$t("invoices.invoice_num"),
                  show: "reference_number",
                },
              }),
              _vm._v(" "),
              _c("table-column", {
                attrs: { label: _vm.$t("invoices.amount"), "sort-as": "total" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (row) {
                      return [
                        _c("span", [_vm._v(_vm._s(_vm.$t("invoices.amount")))]),
                        _vm._v(" "),
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$utils.formatMoney(
                                row.nominal_amount,
                                row.customer.currency
                              )
                            ),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("table-column", {
                attrs: {
                  label: _vm.$t("invoices.prePayment"),
                  "sort-as": "request_level",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (row) {
                      return [
                        _c("span", [
                          _vm._v(" " + _vm._s(_vm.$t("invoices.prePayment"))),
                        ]),
                        _vm._v(" "),
                        row.request_level == "Pending" &&
                        row.funder_invoices.user
                          ? _c(
                              "span",
                              {
                                class:
                                  "inv-status-" +
                                  row.request_level.toLowerCase(),
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(row.request_level) +
                                    "-" +
                                    _vm._s(row.funder_invoices.user.name)
                                ),
                              ]
                            )
                          : row.request_level == "Financed"
                          ? _c(
                              "span",
                              {
                                class:
                                  "inv-status-" +
                                  row.request_level.toLowerCase(),
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("general.financing_approved"))
                                ),
                              ]
                            )
                          : _c(
                              "span",
                              {
                                class:
                                  "inv-status-" +
                                  row.request_level.toLowerCase(),
                              },
                              [
                                _vm._v(
                                  "\n            " + _vm._s(row.request_level)
                                ),
                              ]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("table-column", {
                attrs: {
                  sortable: false,
                  filterable: false,
                  "cell-class": "action-dropdown no-click",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (row) {
                      return [
                        _c("span", [_vm._v(_vm._s(_vm.$t("invoices.action")))]),
                        _vm._v(" "),
                        _c(
                          "v-dropdown",
                          [
                            _c(
                              "a",
                              {
                                attrs: { slot: "activator", href: "#" },
                                slot: "activator",
                              },
                              [_c("dot-icon")],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-dropdown-item",
                              [
                                _vm.userType === "supplier" ||
                                _vm.userType === "anchor" ||
                                _vm.userType === "super_admin"
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass: "dropdown-item",
                                        attrs: {
                                          to: {
                                            path:
                                              "preapproved-invoices/" +
                                              row.id +
                                              "/attachment",
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "dropdown-item-icon",
                                          attrs: { icon: "file" },
                                        }),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("invoices.attachments")
                                            ) +
                                            "\n              "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.userType == "super_admin" &&
                            row.pre_pay == 1 &&
                            row.request_level == "Requested"
                              ? _c("v-dropdown-item", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#/" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openPrepaymentVerified(
                                            row.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "dropdown-item-icon",
                                        attrs: { icon: ["far", "comment"] },
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "invoices.review_prePayment_request"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userType == "super_admin" &&
                            row.pre_pay == 1 &&
                            (row.request_level == "Verified" ||
                              row.request_level == "Approved" ||
                              row.request_level == "Pending")
                              ? _c("v-dropdown-item", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#/" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.reviewPrepaymentRequest(
                                            row.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "dropdown-item-icon",
                                        attrs: { icon: ["far", "comment"] },
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "invoices.review_prePayment_request"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userType == "anchor" &&
                            row.pre_pay === 1 &&
                            (row.request_level === "Verified" ||
                              row.request_level === "Pending")
                              ? _c("v-dropdown-item", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#/" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.reviewPrepaymentRequest(
                                            row.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "dropdown-item-icon",
                                        attrs: { icon: ["far", "comment"] },
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "invoices.review_prePayment_request"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userType == "funder" &&
                            row.pre_pay == 1 &&
                            row.request_level == "Pending"
                              ? _c("v-dropdown-item", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#/" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openPrepaymentPending(
                                            row.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "dropdown-item-icon",
                                        attrs: { icon: ["far", "comment"] },
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "invoices.review_prePayment_request"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userType == "supplier" &&
                            row.pre_pay == 1 &&
                            (row.request_level == "Requested" ||
                              row.request_level == "Verified" ||
                              row.request_level == "Approved" ||
                              row.request_level == "Pending" ||
                              row.request_level == "Finance" ||
                              row.request_level == "Prepaid" ||
                              row.request_level == "Settled" ||
                              row.request_level == "Offer Expired")
                              ? _c("v-dropdown-item", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#/" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.reviewPrepaymentRequest(
                                            row.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "dropdown-item-icon",
                                        attrs: { icon: ["far", "comment"] },
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "invoices.review_prePayment_request"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userType == "super_admin" &&
                            row.pre_pay == 1 &&
                            (row.request_level == "Offered" ||
                              row.request_level == "Financed")
                              ? _c("v-dropdown-item", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#/" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.viewOffer(row.id)
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "dropdown-item-icon",
                                        attrs: { icon: ["far", "comment"] },
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("invoices.view_offer")
                                          ) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            (_vm.userType == "supplier" ||
                              _vm.userType == "funder") &&
                            row.pre_pay == 1 &&
                            row.funder_invoices &&
                            (row.request_level == "Offered" ||
                              row.request_level == "Financed" ||
                              row.request_level == "Rejected")
                              ? _c("v-dropdown-item", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#/" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.viewOffer(row.id)
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "dropdown-item-icon",
                                        attrs: { icon: ["far", "comment"] },
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("invoices.view_offer")
                                          ) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            (_vm.userType == "supplier" &&
                              row.request_level === "Eligible") ||
                            row.request_level === "Rejected"
                              ? _c("v-dropdown-item", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#/" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showPrePaymentRequestPopup(
                                            row.id,
                                            row
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "dropdown-item-icon",
                                        attrs: {
                                          icon: ["far", "question-circle"],
                                        },
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.getPopupText(row)) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userType == "super_admin" &&
                            row.request_level == "Verified"
                              ? _c(
                                  "v-dropdown-item",
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "dropdown-item",
                                        attrs: {
                                          to:
                                            "/super-admin/preappoved-invoice/" +
                                            row.id +
                                            "/funder",
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "dropdown-item-icon",
                                          attrs: { icon: "paper-plane" },
                                        }),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("invoices.sendToFunder")
                                            ) +
                                            "\n              "
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userType == "funder" &&
                            row.request_level != "Settled" &&
                            row.request_level != "BLOCKED"
                              ? _c("v-dropdown-item", [
                                  _vm.userType == "funder" &&
                                  row.request_level == "Financed" &&
                                  row.prepayment == null
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: { href: "#/" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.makePrepayment(row.id)
                                            },
                                          },
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            staticClass: "dropdown-item-icon",
                                            attrs: { icon: ["fas", "check"] },
                                          }),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "invoices.make_prepayment"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-dropdown-item", [
                              _vm.userType === "supplier" &&
                              row.request_level == "Prepaid" &&
                              row.pre_pay == 1 &&
                              row.status != "DRAFT"
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#/" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.needSettlement(row.id)
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "dropdown-item-icon",
                                        attrs: { icon: ["fas", "handshake"] },
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("general.need_settlement")
                                          ) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-dropdown-item",
                              [
                                row.request_level == "Prepaid" ||
                                row.request_level == "Settled"
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass: "dropdown-item",
                                        attrs: {
                                          to: {
                                            path:
                                              "payments/" + row.id + "/record",
                                          },
                                        },
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "dropdown-item-icon",
                                          attrs: { icon: ["fas", "history"] },
                                        }),
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t("general.payment_record")
                                            ) +
                                            "\n              "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-dropdown-item",
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "dropdown-item",
                                    attrs: {
                                      to: {
                                        path: "invoices/" + row.id + "/record",
                                      },
                                    },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "dropdown-item-icon",
                                      attrs: { icon: ["fas", "history"] },
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("general.action_record")
                                        ) +
                                        "\n              "
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            row.request_level == "Eligible" &&
                            (_vm.userType === "anchor" ||
                              _vm.userType === "super_admin")
                              ? _c("v-dropdown-item", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeInvoice(row.id)
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "dropdown-item-icon",
                                        attrs: { icon: ["fas", "trash"] },
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("general.delete")) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userType === "super_admin" &&
                            row.status != "BLOCKED"
                              ? _c("v-dropdown-item", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#/" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.blockedInvoicefunction(
                                            row.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "dropdown-item-icon",
                                        attrs: { icon: ["fas", "ban"] },
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("general.blocked")) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userType === "super_admin" &&
                            row.status === "BLOCKED"
                              ? _c("v-dropdown-item", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      attrs: { href: "#/" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.unblockedInvoicefunction(
                                            row.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "dropdown-item-icon",
                                        attrs: { icon: ["fas", "unlock"] },
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("general.unblocked")) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.searchingVal ? _c("base-loader") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }